import api from '../config/api';

const cloneService = {
  async getSourceProducts({ search = '', page = 1, size = 20 } = {}) {
    const response = await api.get('/api/admin/clone/products', {
      params: { search: search || undefined, page, size },
    });
    return response.data;
  },

  async getSourceProduct(sourceId) {
    const response = await api.get(`/api/admin/clone/products/${sourceId}`);
    return response.data;
  },

  async cloneProduct(sourceId, overrides = null) {
    const response = await api.post(`/api/admin/clone/products/${sourceId}`, overrides);
    return response.data;
  },
};

export default cloneService;
